module.exports = __webpack_public_path__ + "static/flags/PP-1e9995bf0ee28be8e8ad1288e4da368d.gif";